import React, {useMemo, useState} from 'react'
import {Button, Label, Modal} from '@therms/atalaya'
import {
  DateTime,
  RefsByTypeTitles,
  ReportStateBadge,
  RPCDocs,
  UserNames,
  useToggle,
} from '@therms/react-modules'
import {EditReportRefs} from '@src/modules/Reports/components/EditReportRefs'

interface Props {
  onSave?: (params: {
    refsByType?: RPCDocs.Reports.GetReport.v1.RefsByType
  }) => void
  report: RPCDocs.Reports.GetReport.v1.Report
  reportType: RPCDocs.Reports.GetReport.v1.ReportTypeType
}

function ReportDetailsSection({onSave, report, reportType}: Props) {
  const [showEditRefsModal, toggleShowEditRefsModal] = useToggle(false)
  const [refsByType, setRefsByType] = useState(report.refsByType)

  const refsConfig = useMemo(
    () =>
      Object.values(reportType.refsConfig).filter((config) => config === true),
    [reportType.refsConfig],
  )

  return (
    <div>
      <div>
        <Label>Date</Label> <DateTime mode="date" timestamp={report.date} />
      </div>

      {!!refsConfig.length && (
        <div className="space-x-xs flex">
          <Label>Refs</Label>{' '}
          <RefsByTypeTitles
            refsByType={report.refsByType}
            showDetails={false}
          />{' '}
          {!report.deleted && report.state !== 'closed' && (
            <div>
              <Button
                onClick={toggleShowEditRefsModal}
                subtle
                size="xs"
                variant="main"
              >
                Edit
              </Button>
            </div>
          )}
        </div>
      )}

      <div>
        <Label>Status</Label> <ReportStateBadge state={report.state} />{' '}
        {report.status.title}
      </div>

      <div>
        <Label>Authors</Label>{' '}
        <UserNames userIds={report.authors?.map((a) => a.id)} />
      </div>

      {showEditRefsModal && (
        <Modal
          closeHandler={toggleShowEditRefsModal}
          escPressClose
          header="Edit Refs"
        >
          <EditReportRefs
            actionLabel="Save"
            allowedRefs={reportType.refsConfig}
            onChangeValue={setRefsByType}
            onComplete={() => {
              toggleShowEditRefsModal()
              onSave?.({refsByType})
            }}
            value={refsByType}
          />
        </Modal>
      )}
    </div>
  )
}

export {ReportDetailsSection}
